import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { isTranslationAssetRequest } from '@/app/core/interceptors/translation-asset-request';
import { LoaderService } from '@/app/shared/components/loader/services/loader.service';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
    if (isTranslationAssetRequest(req.url)) {
        return next(req);
    }

    const loaderService = inject(LoaderService);

    loaderService.show();

    try {
        return next(req).pipe(
            finalize(() => {
                loaderService.hide();
            })
        );
    } catch (error) {
        loaderService.hide();
        throw error;
    }
};
